import { useContext, useEffect, useRef, useState } from 'react';
import { WebApiContext } from 'ascendon-web-api';
import { translateFault, generateUnhandledFault } from '../../helpers/faults';

function useUpdateMultipleSubscriptions() {
  const [fault, setFault] = useState(null);
  const [faultStatus, setFaultStatus] = useState(null);
  const [uiModel, setUiModel] = useState(null);
  const WebApi = useContext(WebApiContext);

  const isMounted = useRef(true);

  useEffect(
    () => () => {
      isMounted.current = false;
    },
    [],
  );

  const requestUpdateMultipleSubscriptions = (subscriptionPayloads) => {
    const calls = [];

    subscriptionPayloads.forEach((subscription) => {
      calls.push(
        WebApi.subscriber({
          callName: 'UpdateSubscription',
          keyFactors: ['UpdateSubscription'],
          forceRefresh: true,
          payload: subscription,
        }),
      );
    });

    Promise.all(calls)
      .then((response) => {
        if (isMounted.current) {
          setFaultStatus(false);
          const updateMultipleSubscriptions = response.reduce(
            (accumulator, currentValue) => {
              accumulator.push(currentValue?.data);
              return accumulator;
            },
            [],
          );
          setUiModel(updateMultipleSubscriptions);
        }
      })
      .catch((error) => {
        console.warn({ error });
        setFaultStatus((prevState) => !prevState);
        if (isMounted.current) {
          const code = error?.data?.Code;
          let errorMsg;
          if (!code) {
            const unknownFault = generateUnhandledFault(error.data);
            errorMsg = translateFault(unknownFault).translatedMessage;
            setFault(errorMsg);
          } else {
            errorMsg = translateFault(error.data).translatedMessage;
            setFault(errorMsg);
          }
        }
      });
  };
  return [uiModel, fault, requestUpdateMultipleSubscriptions, faultStatus];
}

export { useUpdateMultipleSubscriptions };
export default useUpdateMultipleSubscriptions;
